import moment from "moment";

const CropImage = async (ratio: any, imageRef: any, urls: any) => {
  return new Promise((resolve, reject) => {
    try {
      if (!imageRef) {
        reject(new Error("Image reference is null or undefined"));
        return;
      }

      // Set crossOrigin BEFORE setting up event handlers and src
      imageRef.crossOrigin = "anonymous";
      
      imageRef.onload = function() {
        try {
          const canvas = document.createElement("canvas");
          const scaleX = imageRef.naturalWidth / imageRef.width;
          const scaleY = imageRef.naturalHeight / imageRef.height;
          const scaleFactor = 10;
          
          canvas.width = ratio.width! * scaleFactor;
          canvas.height = ratio.height! * scaleFactor;
          const ctx = canvas.getContext("2d")!;
          
          ctx.drawImage(
            imageRef,
            ratio.x! * scaleX,
            ratio.y! * scaleY,
            ratio.width! * scaleX,
            ratio.height! * scaleY,
            0,
            0,
            ratio.width! * scaleFactor,
            ratio.height! * scaleFactor
          );
          
          const dataUrl = canvas.toDataURL("image/png", 1.0);
          const blob = dataURLtoBlob(dataUrl);
          const name = moment(new Date()).unix();
          const url = new File([blob], name + "-crop.png", { type: "image/png" });
          
          // Clean up
          imageRef.crossOrigin = "";
          resolve(url);
        } catch (error) {
          imageRef.crossOrigin = "";
          reject(new Error(`Error during image processing: ${error}`));
        }
      };
      
      imageRef.onerror = function(event: any) {
        imageRef.crossOrigin = "";
        console.error("Image failed to load:", urls);
        console.error("Error event:", event);
        reject(new Error(`Failed to load image: ${urls}`));
      };
      
      // Set src AFTER setting up event handlers
      imageRef.src = urls;

      
    } catch (err) {
      console.error("Error in CropImage:", err);
      reject(new Error(`CropImage error: ${err}`));
    }
  });
};

const dataURLtoBlob = (dataURL: string) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export default CropImage;
